import { Stack, Text } from "@mantine/core";

interface DiscountedPriceProps {
  price: number;
  discountedPrice?: number;
  size?: string;
  color?: string;
}

export function DiscountedPrice({
  price,
  discountedPrice,
  size = "clamp(0.8rem, 4vw, 1.3rem)",
  color = "white",
}: DiscountedPriceProps) {
  if (discountedPrice) {
    return (
      <Stack gap={0} align="flex-end">
        <Text size={size} fw={400} c={color} td="line-through" opacity={0.6} pb="xs">
          ₩{price.toLocaleString()}
        </Text>
        <Text size={size} fw={600} c={color}>
          ₩{discountedPrice.toLocaleString()}
        </Text>
      </Stack>
    );
  }

  return (
    <Stack gap={0} align="flex-end">
      <Text size={size} fw={600} c={color}>
        ₩{price.toLocaleString()}
      </Text>
    </Stack>
  );
}
